import { CdkAccordionModule } from '@angular/cdk/accordion';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'nav-menu',
  templateUrl: './nav-menu.component.html',
  standalone: true,
  imports: [CdkAccordionModule, NgClass, NgTemplateOutlet, MatMenuModule],
})
export class NavMenuComponent {
  private readonly observer = inject(BreakpointObserver);
  public text = input<string>('');
  protected readonly isMobileViewport = toSignal(
    this.observer.observe(['(max-width: 1032px)']).pipe(
      takeUntilDestroyed(),
      map((res) => res.matches),
    ),
  );
}
